import { Box } from '@mui/material';
import React from 'react';
import ASTITitle from '../../labels/ASTITitle';
import ASTIText from '../../labels/ASTIText';
import ASTILink from '../../labels/ASTILink';

export default function Shows() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
      gap={4}
    >
      <ASTITitle text="Upcoming Dates" />
      
      <ASTIText text="Contact and/or book us !! Follow us and send us a DM on Instagram -> @astir.oids" />
      
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="80%"
        gap={2}
      >
        <ASTILink url="https://fareharbor.com/embeds/book/boomchicago/items/676940/availability/1888163359/book/?full-items=yes&flow=no" text="Sasha Hoedemaker Appreciation Show - Boom Chicago - 23 Nov" />
        <ASTILink url="https://fareharbor.com/embeds/book/boomchicago/items/676940/availability/1888163359/book/?full-items=yes&flow=no" text="ASTIRoids - Impro Lab - A Lab - 10 Dec Nov" />
        <ASTILink url="https://jamwithhumans.com/" text="Humans & Friends - MiniFest - Cinetol - 14 Dec" />
        <ASTIText text="1st Leiden show ? - Feb-March 2026 " />
        <ASTILink url="https://impronation.nl/index.php/shows/" text="ImproNation - Den Haag - May 29th 2026" />

      </Box>

      <ASTITitle text="Past Dates" />
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="80%"
        gap={2}
      >
        <ASTIText text="Humans & Friends - Jam with Humans - Parlour - 13 Oct" />
        <ASTIText text="ImproNation - Den Haag - 3rd Oct" />
        <ASTIText text="Dystopia - Mike's Badhuistheater - 1st Oct" />
        <ASTIText text="Big Sing Festival - Barcelona - 28 June" />
        <ASTIText text="Humans & Friends - Jam with Humans - Parlour - 15 Jun" />
        <ASTIText text="Humans & Friends - Jam with Humans - Parlour - 11 May" />
        <ASTIText text="ASTIRoids - Supermercator - 09 May" />
        <ASTIText text="Cliffs of Dover - Boomspijker - 19 Apr" />
        <ASTIText text="Humans & Friends - Jam with Humans - Parlour - 13 Apr" />
        <ASTIText text="ASTIRoids - ImproNation Den Haag - 21 Mar" />
        <ASTIText text="Thuisparty - Boom Chicago - 23 Feb" />
        <ASTIText text="Showjam - Impro Eindhoven - 14 Feb" />
        <ASTIText text="Jam with Humans & ASTIRoids - Spark Rotterdam - 30 Jan 25" />
        <ASTIText text="Jam with Humans & ASTIRoids - Ruby Hotel - 19 Dec 24" />
        <ASTIText text="ASTIRoids - Bar BaggerBeest - 14th of December 24" />
        <ASTIText text="Jam with Humans mini Fest - The Parlour - 8th of December 24" />
        <ASTIText text="Lazer Lazer - OT301 - Ventilator Cinema - 6th of December 24" />
        <ASTIText text="Jam with Humans – The Parlour – 3rd of November 2024" />
        <ASTIText text="Land of Giants – Easylaughs - CREA Muziekzaal – 1st of November 2024" />
        <ASTIText text="Jam with Humans – The Parlour – 22nd of September 2024" />
        <ASTIText text="2-year Anniversary Show – OT301/Ventilator Cinema – 14th of September 2024" />
        <ASTIText text="Jam with Humans – The Parlour – 8th of September 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 1st of June 2024" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 2nd of May 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 24th of March 2024" />
        <ASTIText text="Jam with Humans – Q-Factory – 7th of November 2023" />
        <ASTIText text="Jam with Humans – Q-Factory – 13th of October 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 12th of October 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 7th of September 2023" />
        <ASTIText text="Boom Chicago Comedy Festival – Boom Chicago – 16th of July 2023" />
        <ASTIText text="Easylaughs – CREA Muziekzaal - 2nd of June 2023"  />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 18th of May 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 30th of March 2023" />
        <ASTIText text="Tag-Out Theater – Mike's Badhuistheater – 16th of February 2023" />
        <ASTIText text="Boom Chicago Comedy Festival – Boom Chicago – 17th of July 2022" />
        
      </Box>

    </Box>
  );
}
